import React, {useState} from 'react';
import {currentResource, labels} from '../../../util/utils';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import EllipseControl from '../../Common/EllipsesControl/EllipsesControl';

export function EditRiskContainer(props) {
	const {isShared, riskTypeChange, riskTypeId} = props;
	const [selectedRiskType, setSelectedRiskType] = useState('');

	const type = currentResource.riskTypes;

	const formatSelectedLabel = ({label}) => {
		return (
			<section className="selectText">
				<EllipseControl id="formatRiskLabel" content={label} tooltip={label} noOfLines={1} />
			</section>
		);
	};

	const onRiskTypeChange = (option) => {
		riskTypeChange(option);
	};

	return (
		<section className="riskType">
			<ReactSelect
				formLabel={labels.type}
				groupHeading
				id="riskType"
				formatOptionLabel={formatSelectedLabel}
				isSearchable
				defaultValue={type[Number(riskTypeId) - 1]}
				options={type}
				onChange={onRiskTypeChange}
				value={type[Number(riskTypeId) - 1]}
				noOptionsMessage={() => labels.noResultsFound}
				isDisabled={isShared}
			/>
		</section>
	);
}

export default EditRiskContainer;
